import { usePermissionStore } from "controller";
import { UnautherizedScreen } from "pages/error-screens/UnautherizedScreen";
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useLocation, useParams } from "react-router-dom";
import { debugConsole } from "utilz/helpers";
// @ts-ignore
const CustomerPermissionContext = createContext<any>();

export const CustomerPermissionProvider = ({
  customerId,
  children,
}: {
  customerId: string;
  children: React.ReactNode;
}) => {
  const doesHavePermissionToCustomer = usePermissionStore(
    (state) => state.doesHavePermissionToCustomer,
  );
  const doesHaveFullAccessToCustomer = usePermissionStore(
    (state) => state.doesHaveFullAccessToCustomer,
  );

  const { isAuthorized, doesHaveFullAccess } = useMemo(() => {
    return {
      isAuthorized: doesHavePermissionToCustomer(customerId || ""),
      doesHaveFullAccess: doesHaveFullAccessToCustomer(customerId || ""),
    };
  }, [customerId]);
  debugConsole(
    "🚀 ~ const{isAuthorized,doesHaveFullAccess}=useMemo ~ doesHaveFullAccess:",
    doesHaveFullAccess,
  );
  debugConsole(
    "🚀 ~ const{isAuthorized,doesHaveFullAccess}=useMemo ~ isAuthorized:",
    isAuthorized,
  );
  return (
    <CustomerPermissionContext.Provider value={doesHaveFullAccess}>
      {isAuthorized ? children : <UnautherizedScreen />}
    </CustomerPermissionContext.Provider>
  );
};

export const useGetDoesHaveCustomerFullAccess = () => {
  const doesHaveFullAccess = useContext(CustomerPermissionContext);
  return doesHaveFullAccess;
};
